import { render } from "./form-error.vue?vue&type=template&id=2a997b81"
import script from "./form-error.vue?vue&type=script&lang=js"
export * from "./form-error.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__